<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.94.867a2.965 2.965 0 0 1 4.193 4.194l-5.378 5.373a4.87 4.87 0 0 1-3.466 1.437h-2.16v-2.16a4.87 4.87 0 0 1 1.437-3.468L10.94.867ZM8.662 9.34l5.373-5.375.003.002a1.417 1.417 0 0 0-2.003-2.002L6.66 7.339a3.334 3.334 0 0 0-.984 2.372v.612h.612a3.334 3.334 0 0 0 2.374-.984Z"
      fill="currentColor"
    />
    <path
      d="M2.839 16h9.29a2.839 2.839 0 0 0 2.838-2.839V9.806a.774.774 0 1 0-1.548 0v3.355a1.29 1.29 0 0 1-1.29 1.29h-9.29a1.29 1.29 0 0 1-1.29-1.29v-9.29c0-.713.577-1.29 1.29-1.29h3.354a.774.774 0 0 0 0-1.549H2.84A2.839 2.839 0 0 0 0 3.871v9.29A2.839 2.839 0 0 0 2.839 16Z"
      fill="currentColor"
    />
  </svg>
</template>
